// extracted by mini-css-extract-plugin
module.exports = {"foodChainInformation":"foodChainInformation_foodChainInformation__2njfh","input":"foodChainInformation_input__pxPXy"};